import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["language"];
import http from 'hub-http/clients/apiClient';
import { BLOG_API_BASE_URL, AUTHORS_PER_PAGE } from '../Constants';
const url = `${BLOG_API_BASE_URL}/blog-authors`;
const ALLOWED_PROPERTIES = ['avatar', 'bio', 'created', 'email', 'facebook', 'fullName', 'name', 'linkedin', 'twitter', 'website', 'slug', 'language'];
function filterFields(data) {
  return Object.assign({}, ...ALLOWED_PROPERTIES.map(field => data[field] ? {
    [field]: data[field]
  } : null));
}
function fetch(blogPostLanguage, search, page = 1) {
  return http.get(`${url}/search-assignable`, {
    query: {
      limit: AUTHORS_PER_PAGE,
      property: ['id', 'avatar', 'bio', 'email', 'facebook', 'fullName', 'name', 'linkedin', 'twitter', 'website', 'language', 'slug', 'translations'],
      order: 'name',
      blogPostLanguage,
      q: search,
      offset: AUTHORS_PER_PAGE * (page - 1)
    }
  });
}
function create(authorData) {
  return http.post(url, {
    data: filterFields(authorData)
  });
}
function createTranslation(_ref, masterId, masterLanguage) {
  let {
      language
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return http.post(`${url}/${masterId}/create-language-variation`, {
    data: {
      blogAuthor: filterFields(rest),
      masterLanguage,
      language
    }
  });
}
export default {
  create,
  fetch,
  createTranslation
};